<template>
	<div class="container">
		<banner/>
		<div class="main">
			<div class="content">
				<div class="content-title">
					<!-- <div class="content-title-item" :class="active == 1 ? 'active':''" @click="setIndex(1)">全部</div> -->
					<el-select v-model="sortType" @change="setIndex(1)" @focus="focus"  placeholder="" class="lable-select content-title-item" :class="active != 2 ? 'active':''">
						<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
					<div class="content-title-item" :class="active == 2 ? 'active':''" @click="setIndex(2)">精选</div>
					<div class="post-stats">
						<div class="post-stats-inner">
							<div class="post-stats-left">
								<span class="stat-item">
									<span class="stat-label">今日</span>
									<span class="stat-value is-today">{{ todayPostCount }}</span>
								</span>
								<span class="stat-divider"></span>
								<span class="stat-item">
									<span class="stat-label">昨日</span>
									<span class="stat-value">{{ yesterdayPostCount }}</span>
								</span>
								<span class="stat-divider"></span>
								<span class="stat-item">
									<span class="stat-label">总帖</span>
									<span class="stat-value">{{ totalPostCount }}</span>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="scroll-container">
					<div   
						ref="scrollContainer"
						class="infinite-list"
						v-infinite-scroll="getDataList"
					>
					<div v-for="item in dataList" :key="item.id" >
						<!-- 回答类型--> 
						<questions v-if="item.categoryScene == 'QUESTION'" :item="item" :type="item.categoryScene"/>
						<!-- 建议类型 -->
						<suggestion v-else-if="item.categoryScene == 'SUGGEST'" :item="item" :type="item.categoryScene" />
						<!-- 其他普通类型 -->
						<articleCard v-else :item="item" :type="item.categoryScene"/>	
					</div>
					<div v-if="loading" class="loading-text">加载中...</div>
					<div v-if="noMore" class="no-more-text">没有更多数据了</div>
					</div>
				</div>
				
				<!-- <Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/> -->
			</div>
			<div class="aside">
				<asideNews/>
				<asideCircle/>
				<asideFollow/>
				<!-- <asideActive/> -->
			</div>
		</div>
		<div 
			v-if="visible"
			class="modal-mask"
			@click.self="closeModal"
			@keydown.esc="closeModal"
			tabindex="0"
		>
			<!-- 弹框主体 -->
			<div class="modal-container" :class="{ 'modal-enter': visible }">
				<!-- 关闭按钮 -->
				<img class="modal-close" @click="closeModal" src="@/assets/close.png"/>
				
				<!-- 内容区域 -->
				<div class="modal-content">
					<h2 class="modal-title">欢迎您访问麒麟社区</h2>
					
					<div class="feature-list">
						<div 
							v-for="(item, index) in features"
							:key="index"
							class="feature-item"
							@click="handleItemClick(index)"
						>
							<span class="item-number">{{ index + 1 }}.</span>
							{{ item }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import banner from './banner.vue'
	import articleCard from '@/components/articleCard'
	import questions from '@/components/questions'
	import suggestion from '@/components/suggestion'
	import asideNews from '@/components/aside/news'
	import asideCircle from '@/components/aside/recommendCircle'
	import asideFollow from '@/components/aside/recommendFollow'
	import qs from 'qs'
	import { post,ajaxParam, get } from '@/units/request.js'
	export default {
		mixins: [{
			methods: {
				async checkKylinIdLogin() {
					const forumLoggedIn = !!localStorage.getItem('token')
					try {
						const res = await get('v1/user/ssoConfig', {})
						if (res.data.code != 200) {
							console.log('获取SSO配置失败')
							return
						}
						const { app_key, response_type, redirect_uri, kyId_uri } = res.data.entity
						const baseUri = kyId_uri.replace('/v2/user/sso/oauth/authorize', '')
						const isLoginUrl = `${baseUri}/openapi/state/v2/user/sso/is-login`
						const isLoginRes = await fetch(isLoginUrl, {
							credentials: 'include',
							headers: {
								'X-Kuas-App-Key': app_key
							}
						})
						const kylinLoggedIn = isLoginRes.status === 200
						console.log('麒麟ID登录状态:', kylinLoggedIn, '论坛登录状态:', forumLoggedIn)

						if (!kylinLoggedIn) {
							if (forumLoggedIn) {
								this.logoutForum()
							}
						} else {
							if (!forumLoggedIn) {
								const params = { app_key, response_type, redirect_uri, prompt: 'none' }
								const queryString = new URLSearchParams(params).toString()
								window.location.replace(`${kyId_uri}?${queryString}`)
							}
						}
					} catch (e) {
						console.log('麒麟ID登录状态检测失败', e)
					}
				},
				logoutForum() {
					localStorage.removeItem('token')
					localStorage.removeItem('user')
					window.location.reload()
				}
			}
		}],
		name: 'home',
		components: {
			banner,
			articleCard,
			asideNews,
			asideCircle,
			asideFollow,
			questions,
			suggestion
		},
		data(){
			return {
				pageSize: 30,
				pageNum: 1,
				userId: '',
				dataList: [],
				total: 0,
				visible: false,
				features: [
					'寻找兴趣相投的圈子',
					'麒麟活动专区，点击参与',
					'麒麟专业大赛，点击参与',
					'综合信息，一览无余'
				],
				active:1,
				loading: false,
				options: [
					{
						value: 0,
						label: '新互动'
					}, 
					{
						value: 1,
						label: '最新'
					}, 
					{
						value: 2,
						label: '热门'
					}
				],
				sortType: 0,
				// 帖子统计
				todayPostCount: 0,
				yesterdayPostCount: 0,
				totalPostCount: 0
			}
		},
		created(){
			this.checkKylinIdLogin()
			this.getStatistics()
			let isVisible = localStorage.getItem('isVisible')
			this.visible = isVisible == 'false' ? false : true
		},
		computed: {
			noMore() {
				return this.dataList.length >= this.total
			}
		},
		methods: {

			//获取首页帖子统计数据
			async getStatistics(){
				const res = await post('v1/index/countPostNum', qs.stringify({}))
				if(res.data.code==200){
					const data = res.data.entity || {}
					this.todayPostCount = data.countDayPostNum || 0
					this.yesterdayPostCount = data.countYesterdayPostNum || 0
					this.totalPostCount = data.countAllPostNum || 0
				}
			},
			//获取首页数据列表
			async getDataList(){
				if(this.noMore && this.total != 0 ) return
				this.loading = true
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					userId: localStorage.getItem('userId')||'',
					sortType: this.sortType
				}
				if(this.active == 2) {
					param.categoryId = 3
				}
				ajaxParam(param)
				const res = await post('v1/index/postList', qs.stringify(param))
				if(res.data.code==200){
					this.loading = false
					this.dataList = this.pageNum==1 ? res.data.list : this.dataList.concat(res.data.list)
					if(!this.noMore){
						this.pageNum++
					}
					this.total = res.data.total
				} else {
					this.loading = false
					this.$message.error(res.data.msg)
				}
			},
			closeModal() {
				this.visible = false
				localStorage.setItem('isVisible',false)
			},
			handleItemClick(index) {
				console.log('点击了条目:', index + 1)
				// 这里可以添加具体的点击处理逻辑
			},
			setIndex(index){
				this.active = index
				this.pageNum = 1
				this.dataList = []
				this.total = 0
				this.getDataList()
			},
			focus(){
				this.active = 1
				this.pageNum = 1
				this.dataList = []
				this.total = 0
				this.getDataList()
			}
		}
	}
</script>

<style scoped lang="less">
	.main{
		display: flex;
		justify-content: space-between;
		width: 1180px;
		max-width: 100%;
		margin: 20px auto;
		overflow: hidden;
		box-sizing: border-box;
		.content{
			position: relative;
			flex: 1;
			background: #fff;
			padding: 10px 40px 10px 40px;
			border-radius: 10px;
			height: max-content;
			max-width: 100%;
			overflow: hidden;
			box-sizing: border-box;
			.scroll-container {
				height: 1000px;
				border-radius: 4px;
				padding: 20px;
			}

			.infinite-list {
				height: 100%;
				overflow: auto; /* 允许内容滚动 */
				scrollbar-width: none; /* Firefox */
				-ms-overflow-style: none; /* IE */
				padding: 0;
				margin: 0;
				list-style: none;
			}

			.infinite-list::-webkit-scrollbar {
				display: none; /* WebKit 浏览器 */
			}
			.loading-text,
			.no-more-text {
				text-align: center;
				color: #909399;
				padding: 12px;
				font-size: 14px;
			}

			.content-title{
				// position: absolute;
				display: flex;
				margin-bottom: 20px;
				position: relative;
			}
			.post-stats{
				position: absolute;
				right: 0;
				top: 0;
			}
			.post-stats-inner{
				display: flex;
				align-items: center;
				gap: 24px;
			}
			.post-stats-left{
				display: flex;
				align-items: center;
				gap: 10px;
			}
			.stat-item{
				display: flex;
				align-items: center;
				gap: 4px;
			}
			.stat-label{
				font-size: 12px;
				color: #909399;
			}
			.stat-value{
				font-size: 14px;
				font-weight: 600;
				color: #40414f;
			}
			.stat-value.is-today{
				color: #DD0515;
			}
			.stat-divider{
				width: 1px;
				height: 14px;
				background: #e0e0e0;
			}
			
			
			.content-title-item{
				padding: 0 20px;
				height: 30px;
				line-height: 30px;
				background: #f2f2f2;
				color: #76767e;
				margin-right: 10px;
				border-radius: 6px;
				font-weight: 400;
				cursor: pointer;
				&.active{
					background-color: #e0e0e0;
					color: #40414f;
				}
			}
			.lable-select{
				width: 100px;
				padding: 0;
				border: none;
				:deep .el-input__inner{
					border:none;
					background: #f2f2f2;
					color:#76767e;
					height: 100%;
				}
				:deep .el-input__suffix{
					right: 10px;
				}
				:deep .el-input--suffix .el-input__inner{
					padding-right: 0 !important;
				}
				:deep .el-select__caret{
					height:30px;
					line-height: 30px;
					color:#76767e;
				}
				&.active{
					:deep .el-input__inner{
					border:none;
					background: #e0e0e0;
					color:#40414f;
					height: 100%;
				}
				}
			}
		}
		.aside{
			width: 300px;
			margin-left: 20px;
		}
	}
	/* 遮罩层样式 */
	.modal-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		transition: opacity 0.3s ease;
	}

	/* 弹框容器 */
	.modal-container {
		position: relative;
		width: 290px;
		height: 216px;
		box-sizing: border-box;
		background: white;
		border-radius: 12px;
		padding: 30px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transform: scale(0.9);
		opacity: 0;
		transition: all 0.3s ease;
	}

	/* 入场动画 */
	.modal-enter {
		transform: scale(1);
		opacity: 1;
	}

	/* 关闭按钮 */
	.modal-close {
		position: absolute;
		top: 15px;
		right: 20px;
		width: 17px;
		height: 17px;
		cursor: pointer;
		transition: color 0.3s;
	}

	.modal-close:hover {
		color: #333;
	}

	/* 标题样式 */
	.modal-title {
		text-align: center;
		color: red;
		margin-bottom: 24px;
		font-size: 16px;
	}

	/* 功能列表 */
	.feature-list {
		list-style: none;
		padding: 0;
		margin: 0;
		color: #000;
		margin-left: 30px;
	}

	.feature-item {
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.2s;
		display: flex;
		align-items: center;
		font-size: 13px;
		font-weight: 600;
	}

	.feature-item:hover {
		background: #e9ecef;
		transform: translateX(10px);
	}

	/* 数字编号样式 */
	.item-number {
		display: inline-block;
		width: 24px;
		height: 24px;
		line-height: 24px;
		text-align: center;
		// background: #3498db;
		color: black;
		border-radius: 50%;
		font-size: 14px;
		flex-shrink: 0;
	}
</style>
